<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('Empresa') }}</h2>
			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="company_name">{{
						$t('Nombre')
					}}</label>
					<input
						type="text"
						v-model="company.company_name"
						id="company_name"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.company.company_name.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.company_name.required"
						>
							{{ $t('name_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.company_name.maxLength"
						>
							{{ $t('name_validation') }}
						</div>
					</div>
				</div>

				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="legal_name">{{
						$t('legal_name')
					}}</label>
					<input
						type="text"
						v-model="company.legal_name"
						id="legal_name"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.company.legal_name.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.legal_name.maxLength"
						>
							{{ $t('legal_name_validation') }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="phone">{{ $t('Telefono') }}</label>
					<input
						type="number"
						v-model="company.phone"
						id="phone"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.company.phone.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.phone.maxLength"
						>
							{{ $t('phone_validation') }}
						</div>
					</div>
				</div>

				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="email">{{ $t('Email') }}</label>
					<input
						type="text"
						v-model="company.email"
						id="email"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.company.email.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.email.email"
						>
							{{ $t('email_invalido') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.email.maxLength"
						>
							{{ $t('email_validation') }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="registry_code">{{ $t('code') }}</label>
					<input
						type="number"
						v-model="company.registry_code"
						id="registry_code"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.company.registry_code.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.company.registry_code.maxLength"
						>
							{{ $t('code_validation') }}
						</div>
					</div>
				</div>
				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="style">{{ $t('Estilo') }}</label>
					<input
						type="color"
						v-model="company.style"
						id="style"
						class="
							w-1/4
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="address">{{ $t('address') }}</label>
				<input
					type="text"
					v-model="company.address"
					id="address"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.company.address.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.company.address.maxLength"
					>
						{{ $t('address_validation') }}
					</div>
				</div>
			</div>

			<h3 class="max-w-md" v-if="image || company.image">
				{{
					(image && image.name) || (company.image && company.image.file_name)
				}}
			</h3>
			<img-upload
				:image="image"
				@upload-image="img_upload"
				@reset-image="img_reset"
			/>
			<div v-if="$v.image.$dirty">
				<div class="text-sm text-red-500 mt-2" v-if="$v.image">
					{{ $t('image_validation') }}
				</div>
			</div>

			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength, email } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import ImgUpload from '@/components/ImgUpload.vue'
import { fetchCompany, insertCompany, updateCompany } from '@/apollo/companies'
import { insertImage } from '@/apollo/images'
import uploadFiles from '@/uploadFiles'

export default {
	apollo: {
		company() {
			const query = fetchCompany(this.id)
			query.skip = this.id == null
			return query
		}
	},
	data() {
		return {
			company: {
				company_name: '',
				registry_code: '',
				legal_name: '',
				address: '',
				phone: '',
				email: '',
				style: '#000000',
				image: null
			},
			section: 'empresas',
			image: null
		}
	},
	components: {
		PulseLoader,
		ImgUpload
	},
	mixins: [single],
	validations() {
		return {
			image: function (img) {
				return img || this.company.image
			},
			company: {
				company_name: {
					required,
					maxLength: maxLength(80)
				},
				registry_code: {
					maxLength: maxLength(10)
				},
				legal_name: {
					maxLength: maxLength(100)
				},
				address: {
					maxLength: maxLength(200)
				},
				phone: {
					maxLength: maxLength(50)
				},
				email: {
					email,
					maxLength: maxLength(100)
				}
			}
		}
	},
	methods: {
		img_reset() {
			this.image = null
		},
		img_upload(img) {
			this.image = img
		},
		async updateSingleCompany() {
			if (this.image) this.company.image = await this.uploadImage(this.image)
			const mutationData = {
				companyId: this.id,
				companyData: {
					...this.company,
					image: undefined,
					image_id: this.company.image.id
				}
			}
			await this.$apollo.mutate(updateCompany(mutationData))
		},

		async insertSingleCompany() {
			this.company.image = await this.uploadImage(this.image)
			const mutationData = {
				companyData: { ...this.company, image: { data: this.company.image } }
			}
			await this.$apollo.mutate(insertCompany(mutationData))
		},

		async uploadImage(image) {
			const name = (await uploadFiles([image]))[0]
			const data = {
				url: '/companies/' + name,
				file_name: name,
				mime: image.type,
				area: 'companies'
			}
			if (this.id && this.image) {
				const apolloResult = await this.$apollo.mutate(insertImage(data))
				data.id = apolloResult.data.image.id
			} else if (this.id) {
				data.id = this.company.image.id
			}
			return data
		},

		validImage() {
			return this.image || this.company.image
		},

		async submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid && this.validImage()) {
				;(this.id ? this.updateSingleCompany() : this.insertSingleCompany())
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
